module.exports = __webpack_public_path__ + "static/media/proffesionals.fb1b6da4.svg";